import React, { useEffect, useState } from 'react';
import CustomTable from '../../components/customTable/CustomTable';
import { getAllOrders, getOrderSearch } from './slice/slice';
import Loader from '../../components/loader/Loader';
import { useDispatch, useSelector } from 'react-redux';

function OrderList() {
    const dispatch = useDispatch();
    const { isLoading, getAllOrdersList, searchOrder } = useSelector(state => state.OrderListSlice);
    const tableHeaders = ['Order ID', 'Purchase Date', 'Subscription', 'Name', 'Billed', 'Status', 'Amount'];
    const [searchText, setSearchText] = useState('');

    useEffect(() => {
        dispatch(getAllOrders());
    }, [dispatch]);

    const handleSearchChange = (newSearchText) => {
        setSearchText(newSearchText);
    };

    useEffect(() => {
        let queryParam = ``;
        if (searchText) {
            queryParam += `?input_search=${searchText}`;
        }
        dispatch(getOrderSearch(queryParam));
    }, [dispatch,searchText]);

    const userData = getAllOrdersList?.map(order => ({
        orderid: order.id,
        purchasedate: new Date(order.create_date).toLocaleDateString(),
        Subscription: 'Premium',
        name: `${order.fname ? order.fname : ''} ${order.lname ? order.lname : ''}`,
        billed: order.billing,
        status: order.status,
        amount: `₹${order.amount.toFixed(2)}`
    })) || [];

    const searchOrderData = searchOrder?.map(order => ({
        orderid: order.id,
        purchasedate: new Date(order.create_date).toLocaleDateString(),
        Subscription: 'Premium',
        name: `${order.fname ? order.fname : ''} ${order.lname ? order.lname : ''}`,
        billed: order.billing,
        status: order.status,
        amount: `₹${order.amount.toFixed(2)}`
    })) || [];

    return (
        <>
            {isLoading && <Loader />}
            <div className='users main-Page-css'>
                <div className='main-page-title'>Order list</div>
                <div style={{ marginTop: 32 }}>
                    <CustomTable
                        showTitle
                        titlehead='Order History'
                        data={searchText ? searchOrderData : userData}
                        headers={tableHeaders}
                        showSearchBarButtons
                        showView
                        showtablecss={true}
                        showPagination
                        showSearchBar='true'
                        onSearchChange={handleSearchChange}
                    />
                </div>
            </div>
        </>
    );
}

export default OrderList;
